<template>
  <div class="portfolio-vertical" uk-lightbox>
    <a
      class="portfolio-section"
      v-for="item in preparedList"
      :key="item.id"
      :href="item.url"
    >
      <AutoVideoPlayer
        class="video"
        v-if="item.isVideo"
        :src="item.url"
        :threshold="0.1"
      />
      <img
        loading="lazy"
        class="image"
        v-else
        :src="item.url"
        :alt="item.title"
      />
    </a>
  </div>
</template>

<script>
import AutoVideoPlayer from './AutoVideoPlayer.vue'

export default {
  components: {
    AutoVideoPlayer,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    preparedList() {
      return this.list.map(item => ({
        id: item.sys.id,
        title: item.fields.title,
        description: item.fields.description,
        category: item.fields.category.fields.categoryName,
        ...item.fields.portfolioImages.map(content => {
          const contentType = content.fields.file.contentType
          const url = content.fields.file.url
          const isVideo = contentType.startsWith('video')
          return {
            isVideo,
            url: isVideo ? url : this.prepareImageUrl(contentType, url),
          }
        })[0],
      }))
    },
  },
  methods: {
    prepareImageUrl(contentType, url) {
      const newUrl = `${url}?q=85`
      if (contentType.endsWith('gif')) {
        return newUrl
      } else {
        return `${newUrl}&fm=jpg&fl=progressive`
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.portfolio-vertical {
  position: relative;
  .portfolio-section {
    position: relative;
    background-color: black;
    max-height: calc(100vh - 66px);
    display: block !important;
    text-align: center;
    .video,
    .image {
      max-height: inherit;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PortfolioVertical.vue